import { InboxNotificationResponse } from 'src/services/api/inboxApi';
import { API } from 'src/utils/AmplifyApiUtils';

export default class InboxClient {
  /**
   * Get inbox notification using group id
   * @param groupID // this is the notification group id
   */
  static async NotificationByGroupId(
    groupID: string,
  ): Promise<InboxNotificationResponse[]> {
    const groupNotifs = await API.get('AppAPI', `/notifications`, {
      queryStringParameters: {
        groupID,
      },
    });
    return groupNotifs.data;
  }

  static async loadAllPaginatedNotifications(
    notifications: InboxNotificationResponse[],
    nextToken: string | undefined = undefined,
  ): Promise<InboxNotificationResponse[]> {
    // call notifications over and over again until we get all notifications
    const getNotificationsResponse = await API.get('AppAPI', `/notifications`, {
      queryStringParameters: {
        nextToken,
        limit: 1000,
      },
    });
    const allNotifications = [
      ...notifications,
      ...getNotificationsResponse.data,
    ];
    if (!getNotificationsResponse.nextToken) {
      return allNotifications;
    }
    return this.loadAllPaginatedNotifications(
      allNotifications,
      getNotificationsResponse.nextToken,
    );
  }
}
